import { render, staticRenderFns } from "./UserManagementTransactionsTab.vue?vue&type=template&id=b9ad716a&lang=pug"
import script from "./UserManagementTransactionsTab.vue?vue&type=script&lang=ts"
export * from "./UserManagementTransactionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports